<template>
  <!-- Kontener zakresowego filtra: flexowy układ w wierszu -->
  <div class="filter d-flex">
    <!-- Etykieta filtra: wyświetla przekazaną nazwę -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora "od": wyświetlany z odpowiednią klasą -->
    <span class="symbol">{{ symbolFrom }}</span>
    <!-- Pole input dla wartości minimalnej:
         - atrybut name odpowiada props.fieldFromName
         - v-model.lazy wiąże wartość po zdarzeniu 'change'
         - blokada scrollowania i dotyku, aby zapobiec przypadkowym zmianom
    -->
    <input
      :name="fieldFromName"
      v-model.lazy="valueFrom"
      type="number"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol operatora "do": analogicznie do 'from' -->
    <span class="symbol">{{ symbolTo }}</span>
    <!-- Pole input dla wartości maksymalnej -->
    <input
      :name="fieldToName"
      v-model.lazy="valueTo"
      type="number"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import { useCurrentFiltersStore } from "../../stores/currentFilters"; // Import store Pinia dla aktualnych filtrów

export default {
  name: "RangeFilter",
  props: ["name", "symbolFrom", "fieldFromName", "symbolTo", "fieldToName"],

  setup(props) {
    const filtersStore = useCurrentFiltersStore();

    // v-model podpinamy bezpośrednio do store przez computed setter.
    // Zapis jest synchroniczny — dzięki temu po kliknięciu „Zastosuj" w kroku 2
    // wartości są w store ZANIM watcher na current.step odpali checkData()
    // i wyśle pierwsze zapytanie. Wcześniej, z `ref` + `watch`, watcher zapisu
    // do store flushował się po watcherze step → pierwsze żądanie szło bez
    // filtrów masy/długości/itp. i wpadał pojazd nie spełniający kryteriów.
    const valueFrom = computed({
      get: () => filtersStore.filters[props.fieldFromName] ?? "",
      set: (val) => filtersStore.addItem(props.fieldFromName, val),
    });
    const valueTo = computed({
      get: () => filtersStore.filters[props.fieldToName] ?? "",
      set: (val) => filtersStore.addItem(props.fieldToName, val),
    });

    return { valueFrom, valueTo, filtersStore };
  },
};
</script>

<style scoped>
/* Usunięcie standardowych przycisków strzałek w input type=number dla WebKit */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Styl kontenera filtra: dolna granica i marginesy */
.filter {
  border-bottom: 1px solid #b7b7b5;
  padding-bottom: 5px;
  margin-top: 5px;
}

/* Usunięcie dolnej granicy dla ostatniego filtra */
.filter:last-child {
  border: none;
}

/* Styl pól input: szerokość, padding i wyśrodkowanie tekstu */
input {
  width: 50px;
  padding: 2px 7px;
  text-align: center;
}

/* Styl symbolu operatora */
.symbol {
  padding: 5px;
}
</style>
